export default __webpack_public_path__ + "static/media/tbPullERP.f7f2ba17.svg";